module.exports = __webpack_public_path__ + "img/gm.6b4a3252.jpg";